'use strict';

exports.__esModule = true;
exports.default = undefined;

var _DockMonitor = require('./DockMonitor');

var _DockMonitor2 = _interopRequireDefault(_DockMonitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DockMonitor2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-devtools-dock-monitor/lib/index.js
 ** module id = 784
 ** module chunks = 0
 **/